package com.schoolconnect.app.datasource.network.response

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class QuickAnnouncementResponse(
    @SerialName("school_id") val schoolId: String? = null,
    val message: String? = null,
    @SerialName("display_until") val displayUntil: String? = null,
    val status: String? = null,
    val id: String? = null,
    @SerialName("qa_id") val qaId: String? = null,
    @SerialName("created_at") val createdAt: String? = null,
    @SerialName("updated_at") val updatedAt: String? = null,
    @SerialName("created_by_name") val createdByName: String? = null,
    @SerialName("created_by_id") val createdById: String? = null,
    @SerialName("updated_by_name") val updatedByName: String? = null
)

@Serializable
data class QuickAnnouncementListResponse(
    val count: Int? = null,
    val items: List<QuickAnnouncementResponse>? = null,
    val counters: Map<String, Int>? = null
)
